export enum SharedField {
  Address = 'address',
  Phone = 'phone',
  Name = 'name',
  Email = 'email',
  MemberId = 'memberId',
}

export enum SharedResult {
  Unshared = 'unshared',
  Shared = 'shared',
  Unknown = 'unknown',
}

export type PermissionValue =
  | SharedResult.Shared
  | SharedResult.Unshared
  | SharedResult.Unknown;

export type Typename = string;

export type SharingPermission = {
  [SharedField.Address]: PermissionValue;
  [SharedField.Phone]: PermissionValue;
  [SharedField.Name]: PermissionValue;
  [SharedField.Email]: PermissionValue;
  [SharedField.MemberId]: PermissionValue;
  __typename?: Typename;
} | null;

export type HonoraryMembershipDataType = {
  __typename?: 'ActiveMembership' | null | undefined;
  clubName?: string | null | undefined;
  type: string | undefined;
  terminationDate?: string | null | undefined;
  clubType?: string | null | undefined;
}[];

export type MembershipDataType = {
  __typename?: 'ActiveMembership' | null | undefined;
  clubName?: string | null | undefined;
  type: string | undefined;
  terminationDate?: string | null | undefined;
  clubType?: string | null | undefined;
}[];
